import { useMemo } from 'react';
import { gql } from '@apollo/client';
import { useMobileMenuHelpAccordion_GetGlobalVariablesQuery } from '#types';
import { useOrgOnboardingModal } from '../../../../hooks/useOrgOnboardingModal';
import { useClientOnboardingModal } from '../../../../hooks/useClientOnboardingModal';
import { CustomListItemType } from '../../CustomListItem/CustomListItemComponent';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getGlobalVariablesQuery = gql`
	query MobileMenuHelpAccordion_getGlobalVariables {
		getGlobalVariables {
			HelpUrl
		}
	}
`;

export const useMobileMenuHelpItems = () => {
	const { data: globalVariableData, loading: globalVariableLoading } =
		useMobileMenuHelpAccordion_GetGlobalVariablesQuery();
	const href = globalVariableData?.getGlobalVariables.HelpUrl;

	const {
		setOpen: setOrgOnboardingModalOpen,
		isOrgOwner,
		...orgOnboardingModalProps
	} = useOrgOnboardingModal();

	const {
		setOpen: setClientOnboardingModalOpen,
		isClientUser,
		...clientOnboardingModalProps
	} = useClientOnboardingModal();

	const loading = globalVariableLoading || !href;

	const items: CustomListItemType[] = useMemo(
		() => [
			{
				id: 'helpLink',
				href: href,
				target: '_blank',
				rel: 'noreferrer',
				label: 'Help Center',
			},
			...( isClientUser || isOrgOwner
				? [
					{
						id: 'orgOnboardingModal',
						label: 'Getting Started',
						onClick: () =>
							isOrgOwner
								? setOrgOnboardingModalOpen( true )
								: setClientOnboardingModalOpen( true ),
					},
				  ]
				: [] ),
		],
		[
			href,
			isOrgOwner,
			isClientUser,
			setOrgOnboardingModalOpen,
			setClientOnboardingModalOpen,
		]
	);

	return {
		items,
		loading,
		clientOnboardingModalProps,
		orgOnboardingModalProps,
	};
};
